import {FelloApiError, FelloApiFailureResponse} from "../auth";

export class FelloApiErrorResponse<T> implements FelloApiFailureResponse<T> {
  success = false as const;
  constructor(public error: FelloApiError, public data?: T) {}
}
